<template>
    <v-card>
        <loading-component :value="loading"/>
        <v-card-title primary-title class="title" style="background-color: #49BD98">
            <v-flex xs12 class="text-xs-center" style="color: white">
                {{ $t("drivers.newCaptain.newCaptain") }}
            </v-flex>
        </v-card-title>
        <v-card-text>
            <v-form ref="form">
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">{{ $t("drivers.newCaptain.phoneNumber") }}</v-flex>
                    <v-flex xs6>
                        <v-text-field v-model="captain.username" :rules="[required]" :label="$t('drivers.newCaptain.phone')"/>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">{{ $t("drivers.newCaptain.firstName") }}</v-flex>
                    <v-flex>
                        <v-text-field v-model="captain.first_name" :rules="[required]"
                                      :label="$t('drivers.newCaptain.firstName')"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">{{ $t("drivers.newCaptain.lastName") }}</v-flex>
                    <v-flex>
                        <v-text-field v-model="captain.last_name" :rules="[required]" :label="$t('drivers.newCaptain.lastName')"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">{{ $t("drivers.newCaptain.gender") }}</v-flex>
                    <v-flex>
                        <ChooseGender v-model="captain.gender"/>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">{{ $t("drivers.newCaptain.carPlate") }}</v-flex>
                    <v-flex>
                        <v-text-field v-model="car.number" :rules="[required]" :label="$t('drivers.newCaptain.carPlate')"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout align-baseline>
                    <v-flex xs6 class="label font-weight-bold">{{ $t("drivers.newCaptain.carStateTitle") }}</v-flex>
                    <v-flex>
                        <v-select :items="api.CONSTANTS.STATES" v-model="car.state" :rules="[required]"
                                  :label="$t('drivers.newCaptain.carState')"/>
                    </v-flex>
                </v-layout>
                <v-layout justify-center>
                    <v-btn color="primary" @click="save">
                        {{ $t("drivers.newCaptain.createCaptain") }}
                    </v-btn>
                </v-layout>
            </v-form>
        </v-card-text>
        <v-divider/>
    </v-card>
</template>

<script>
    import ChooseGender from "@/components/monaco/input/ChooseGender";
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        components: {LoadingComponent, ChooseGender},
        data() {
            return {
                loading: false,
                captain: {
                    username: null,
                    first_name: null,
                    last_name: null,
                    gender: 1
                },
                car: {
                    number: null,
                    state: null
                }
            }
        },
        methods: {
            save() {
                if (!this.$refs.form.validate())
                    return;

                this.loading = true;
                const {captain, car} = this.$data;
                this.axios.post(this.api.ACTIONS.CAPTAINS, {
                    captain,
                    car
                }).then(({data: {data}}) => {
                    this.$emit("created", data);
                }).catch(({response: {data}}) => window.getApp.$emit("SHOW_TOAST", data.message, "red"))
                    .finally(() => this.loading = false)
            }
        },
        computed: {
            required() {
                return val => !!val || this.$t('drivers.newCaptain.requiredField');

            }
        },
        name: "new-captain"
    }
</script>

<style scoped>

</style>